import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import Wellbeing from "../tabs/Wellbeing";
import useMcapFilters from "../useMcapFilters";
import typography from "../typography";

export default function WellbeingScreen() {
  const { filters, renderFilterBar } = useMcapFilters();

  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_WELLBEING} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_WELLBEING} />
        <Wellbeing filters={filters} filterBar={renderFilterBar("wellbeing")} />
      </Container>
    </div>
  );
}
